import type { PillarCode } from '../lib/api';

export const PILLAR_LEGAL_NAMES: Record<PillarCode, string> = {
  CGS: 'CALM Global Services LLC',
  CLM: 'CLM Construction LLC',
  CAC: 'CALM Construction LLC',
};

interface Props {
  granted: PillarCode[];
  active: PillarCode | null;
  onChange: (scope: PillarCode | null) => void;
}

/**
 * §1.4: the switcher offers only pillars the user has been granted, and
 * "All entities" only when more than one is granted. A single-pillar user has
 * their scope auto-pinned at login and is never shown a control that implies
 * a wider view exists.
 */
export function PillarSwitcher({ granted, active, onChange }: Props): JSX.Element | null {
  if (granted.length <= 1) return null;

  return (
    <div className="flex flex-wrap items-center gap-1" role="group" aria-label="Entity scope">
      <button
        type="button"
        onClick={() => onChange(null)}
        aria-pressed={active === null}
        className={`h-9 rounded-pill px-3 text-micro font-medium uppercase ${
          active === null
            ? 'bg-royal text-white'
            : 'border border-border bg-white text-text-secondary hover:bg-surface'
        }`}
      >
        All entities
      </button>
      {granted.map((pillar) => (
        <button
          key={pillar}
          type="button"
          onClick={() => onChange(pillar)}
          aria-pressed={active === pillar}
          title={PILLAR_LEGAL_NAMES[pillar]}
          className={`h-9 rounded-pill px-3 text-micro font-medium uppercase ${
            active === pillar
              ? 'bg-royal text-white'
              : 'border border-border bg-white text-text-secondary hover:bg-surface'
          }`}
        >
          {pillar}
        </button>
      ))}
    </div>
  );
}
